import { Nav } from '@/components/Nav'
import { Hero } from '@/components/Hero'
import { BenefitsBar } from '@/components/BenefitsBar'
import { ResultsSection } from '@/components/ResultsSection'
import { HowItWorks } from '@/components/HowItWorks'
import { ComparisonSection } from '@/components/ComparisonSection'
import { TechSection } from '@/components/TechSection'
import { AppScreenshots } from '@/components/AppScreenshots'
import { PlansSection } from '@/components/PlansSection'
import { FaqSection } from '@/components/FaqSection'
import { LegalBanner } from '@/components/LegalBanner'
import { FinalCta } from '@/components/FinalCta'
import { Footer } from '@/components/Footer'

export function App() {
  return (
    <div className="min-h-screen">
      <Nav />
      <main>
        <Hero />
        <BenefitsBar />
        <ResultsSection />
        <HowItWorks />
        <ComparisonSection />
        <TechSection />
        <AppScreenshots />
        <PlansSection />
        <FaqSection />
        <LegalBanner />
        <FinalCta />
      </main>
      <Footer />
    </div>
  )
}
